import { EventTimeVersionEnum } from '../../../app.enums';

export class UserBindingModel implements IUserBindingModel {
  'userId': number;
  'email': string;
  'phone': string;
  'firstName': string;
  'lastName': string;
  'userName': string;
  'profilePicture': string;
  'culture': string;
  'currencySymbol': string;
  'currency': string;
  'roleName': string;
  'isContain24HourFormat': boolean;
  'sslDomain': string;
  'totalActiveEvents': number;
  'hostedPlanCreatedDate': Date;
  'paymentGateway': string;
  'hostedPlanBillingType': string;
  'isDisplayMembershipSettings': boolean;
  'applicationId': string;
  'classPassEnabled': boolean;
  'lastPasswordUpdated': any;
  'eventTimeVersion': EventTimeVersionEnum;
  'isShowOnboardingHelpOption': boolean;
  'requiresEventChecklist': boolean;
  'isImportAndEmailAttendee': boolean;
  'isSuspiciousSender': boolean;
  'isDonorPerfectConnected': boolean;

  constructor(data?: IUserBindingModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userId = data['userId'];
      this.email = data['email'];
      this.phone = data['phone'];
      this.firstName = data['firstName'];
      this.lastName = data['lastName'];
      this.userName = data['userName'];
      this.profilePicture = data['profilePicture'];
      this.culture = data['culture'];
      this.currencySymbol = data['currencySymbol'];
      this.currency = data['currency'];
      this.roleName = data['roleName'];
      this.isContain24HourFormat = data['isContain24HourFormat'];
      this.sslDomain = data['sslDomain'];
      this.totalActiveEvents = data['totalActiveEvents'];
      this.hostedPlanCreatedDate = data['hostedPlanCreatedDate'];
      this.paymentGateway = data['paymentGateway'];
      this.hostedPlanBillingType = data['hostedPlanBillingType'];
      this.isDisplayMembershipSettings = data['isDisplayMembershipSettings'];
      this.classPassEnabled = data['classPassEnabled'];
      this.applicationId = data['applicationId'];
      this.lastPasswordUpdated = data['lastPasswordUpdated'];
      this.eventTimeVersion = data['eventTimeVersion'];
      this.isShowOnboardingHelpOption = data['isShowOnboardingHelpOption'];
      this.requiresEventChecklist = data['requiresEventChecklist'];
      this.isImportAndEmailAttendee = data['isImportAndEmailAttendee'];
      this.isSuspiciousSender = data['isSuspiciousSender'];
      this.isDonorPerfectConnected = data['isDonorPerfectConnected'];
    }
  }

  static fromJS(data: any): UserBindingModel {
    let result = new UserBindingModel();
    result.init(data.data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['email'] = this.email;
    data['phone'] = this.phone;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['userName'] = this.userName;
    data['profilePicture'] = this.profilePicture;
    data['culture'] = this.culture;
    data['currencySymbol'] = this.currencySymbol;
    data['currency'] = this.currency;
    data['roleName'] = this.roleName;
    data['isContain24HourFormat'] = this.isContain24HourFormat;
    data['sslDomain'] = this.sslDomain;
    data['totalActiveEvents'] = this.totalActiveEvents;
    data['hostedPlanCreatedDate'] = this.hostedPlanCreatedDate;
    data['paymentGateway'] = this.paymentGateway;
    data['hostedPlanBillingType'] = this.hostedPlanBillingType;
    data['isDisplayMembershipSettings'] = this.isDisplayMembershipSettings;
    data['classPassEnabled'] = this.classPassEnabled;
    data['applicationId'] = this.applicationId;
    data['lastPasswordUpdated'] = this.lastPasswordUpdated;
    data['eventTimeVersion'] = this.eventTimeVersion;
    data['isShowOnboardingHelpOption'] = this.isShowOnboardingHelpOption;
    data['requiresEventChecklist'] = this.requiresEventChecklist;
    data['isImportAndEmailAttendee'] = this.isImportAndEmailAttendee;
    data['isSuspiciousSender'] = this.isSuspiciousSender;
    data['isDonorPerfectConnected'] = this.isDonorPerfectConnected;
    return data;
  }
}

export interface IUserBindingModel {
  userId: number;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  userName: string;
  profilePicture: string;
  culture: string;
  currencySymbol: string;
  currency: string;
  roleName: string;
  isContain24HourFormat: boolean;
  sslDomain: string;
  totalActiveEvents: number;
  hostedPlanCreatedDate: Date;
  paymentGateway: string;
  hostedPlanBillingType: string;
  isDisplayMembershipSettings: boolean;
  classPassEnabled: boolean;
  applicationId: string;
  lastPasswordUpdated: any;
  eventTimeVersion: EventTimeVersionEnum;
  isShowOnboardingHelpOption: boolean;
  requiresEventChecklist: boolean;
  isImportAndEmailAttendee: boolean;
  isSuspiciousSender: boolean;
  isDonorPerfectConnected: boolean;
}

export interface InviteMembersResponse {
  isSuccessful: boolean;
  errorMessage: string;
  data: InviteMembersData;
}
export interface IGenerateScanKey {
  isSuccessful: boolean;
  errorMessages: any[];
  statusCode: number;
  data: string;
}
export interface InviteMembersData {
  responseMessage: string;
  email: string;
  role: string;
  userId: number;
  isSuccess: boolean;
  isChangeInvitationRole: boolean;
}

export interface InviteMembersModelPayload {
  firstName?: string;
  lastName?: string;
  email: string;
  stRoleType: number;
}

export enum UserRoleName {
  admin = 'Admin',
  manager = 'Manager',
  checkIn = 'CheckIn',
  boxOffice = 'BoxOffice',
  promoter = 'Promoter',
  customer = 'Customer',
  owner = 'Owner',
  seatTagger = 'SeatTagger',
  salesCheckInOrderEditing = 'SalesCheckInOrderEditing',
}
